module.exports = __webpack_public_path__ + "static/KC_global-d7b9145c92101bf4cb6024a638b70e12.png";